import React from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton, Typography } from '@material-ui/core';

import { TrashIcon, EditIcon } from 'components/icons';

import { getFormByCurrentLanguage } from 'utils/form-localization/formLocalization';

import { useStyles } from './styles';

const BookRelatedField = ({ title, addOns, mandatoryFees, editCallBack, deleteCallBack }) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  return (
    <div className={classes.wrapper}>
      <div className={classes.info}>
        <Typography variant="body1" className={classes.title}>
          {title}
        </Typography>
        {addOns && !!addOns.length && (
          <Typography variant="body1">
            {addOns
              .filter(item => item.value && parseInt(item.value))
              .map(
                item =>
                  `${item.value}x ${
                    getFormByCurrentLanguage(
                      selectedLanguage,
                      item,
                      item['Norwegian']
                    ).title
                  } `
              )
              .join('• ')}
          </Typography>
        )}
      </div>
      <div className={classes.info}>
        <Typography variant="body1" className={classes.title}>
          {title}
        </Typography>
        {mandatoryFees && !!mandatoryFees.length && (
          <Typography variant="body1">
            {mandatoryFees
              .filter(item => item.value && parseInt(item.value))
              .map(
                item =>
                  `${item.value}x ${
                    getFormByCurrentLanguage(
                      selectedLanguage,
                      item,
                      item['Norwegian']
                    ).title
                  } `
              )
              .join('• ')}
          </Typography>
        )}
      </div>
      <div className={classes.actions}>
        <IconButton
          onClick={editCallBack}
          className={classes.iconButton}
          disableTouchRipple={true}
          disableFocusRipple={true}
          aria-label="edit"
        >
          <EditIcon />
        </IconButton>
        <IconButton
          onClick={deleteCallBack}
          className={classes.iconButton}
          disableTouchRipple={true}
          disableFocusRipple={true}
          aria-label="delete"
        >
          <TrashIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default BookRelatedField;
